import { FC } from "react";
import { useIntl } from "react-intl";
import { useOrgInfo } from "@src/common/reliablePartnerApi";
import { useAppSelector } from "@src/reduxStore";

export interface LinkToZeckitProps {
  orgBusinessId?: string;
}

const LinkToZeckit: FC<LinkToZeckitProps> = ({ children, orgBusinessId }) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();
  const orgInfo = useOrgInfo();
  const businessId = orgBusinessId || orgInfo.data?.registrationNumber;

  if (!businessId) {
    return null;
  }

  return (
    <a
      href={intl.formatMessage(
        {
          id: "zeckitUrl",
          defaultMessage: "{zeckitUrl}/selvitys/FI/{orgBusinessId}?lang=fi",
        },
        {
          orgBusinessId: businessId,
          zeckitUrl: config?.zeckitUrl,
        }
      )}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToZeckit;
